import React from 'react'
import { Container } from 'react-bootstrap'
import Meta from '../components/Meta'

const TermsScreen = () => {
  return (
    <Container>
      <Meta title='Terms & Conditions — lotustor.com' robots='index,follow' />
      <h1>Terms & Conditions</h1>
      <p>Last updated: October 25, 2025</p>
      <h3>Use of the Site</h3>
      <p>By using this site, you agree to abide by these Terms & Conditions and all applicable laws.</p>
      <h3>Orders and Payment</h3>
      <p>All orders are subject to availability and acceptance. Prices are subject to change without notice.</p>
      <h3>Shipping and Delivery</h3>
      <p>We will use reasonable efforts to meet delivery timeframes but cannot guarantee specific delivery dates.</p>
      <h3>Returns</h3>
      <p>Returns are accepted according to our Returns Policy. Certain items may be ineligible for return.</p>
      <h3>Limitation of Liability</h3>
      <p>To the maximum extent permitted by law, we are not liable for indirect or consequential damages.</p>
      <h3>Contact</h3>
      <p>For questions regarding these terms, please reach out via the Contact page.</p>
    </Container>
  )
}

export default TermsScreen
